import { $ } from "./imports";
import { getLanguage } from "./get-language";

// Filtro de especificacion(referencia) en detalle de producto
const specificationFilter = () => {

    const textSpecifications = {
        "es": {
            "label": "Selecciona una referencia"
        },
        "en": {
            "label": "Select a reference"
        }
    }

    // Obtener select
    let $originalSelect = $('body.page-node-type-products-detail .views-element-container .view-filters form select');

    let $target = $('.specifications__form');

    if($originalSelect.length > 0){
        if($('.reference__label').length <= 0 && $('.reference__select').length <= 0){
            let texto = textSpecifications[getLanguage()].label;

            $target.append(`<label for="productReference" class="reference__label">${texto}</label>`);

            // Clonamos el select, añadimos nuevos atributos e insertamos en el DOM
            $originalSelect.clone().attr({
                'id': 'productReference',
                'name': 'productReference',
                'class': 'reference__select'
            }).appendTo($target);            
            // .attr('id', 'productReference').attr('name', 'productReference').appendTo($('#d2'));

        }

        // Escuchamos evento en el nuevo select
        $('body').on('change', '.reference__select', function(){
            let value= $(this).val();
            // Asignamos "value" al select
            $originalSelect.val(value);
            $originalSelect.trigger('change');
        });
    }
};

export default specificationFilter;